export const colors = [
  { id: 1, name: 'Azul Claro', color: '#4DA6FF' },
  { id: 2, name: 'Azul Pastel', color: '#B3E5FC' },
  { id: 3, name: 'Laranja Claro', color: '#FFB347' },
  { id: 4, name: 'Amarelo Pastel', color: '#FDE68A' },
  { id: 5, name: 'Rosa Claro', color: '#F6BDC0' },
  { id: 6, name: 'Bege Claro', color: '#F5F5DC' },
  { id: 7, name: 'Cinza Médio', color: '#C4C4C4' },
  { id: 8, name: 'Cinza Azulado', color: '#D9E2EC' },
  { id: 9, name: 'Roxo Lavanda', color: '#D8BFD8' },
  { id: 10, name: 'Roxo Claro', color: '#C3AED6' },
  { id: 11, name: 'Rosa Chá', color: '#F4CCCC' },
  { id: 12, name: 'Marrom Claro', color: '#D2B48C' },
  { id: 13, name: 'Laranja Avermelhado', color: '#E97777' },
  { id: 14, name: 'Verde Menta', color: '#A9F0D1' },
  { id: 15, name: 'Verde Musgo Claro', color: '#B8D8BA' }
]
